<template>
    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                    <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
                <template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href"  @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
                </Breadcrumb>
                <Toast />
                <div class="p-fluid formgrid grid" style="margin-top: 2%">
                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <InputText type="text" v-model="search_name"></InputText>
                            <label for="name">Album Name </label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-2">
                        <Button style="background-color: #349ce4; border: 1px solid #349ce4" icon="pi pi-search"
                            @click="search(1)" v-tooltip.bottom="'Search'" ></Button>
                    </div>
                </div>
                <DataView :value="products" :layout="layout" :rows="rows">
                    <template #empty>
                        <div class="text-center">
                            <b style="text-align: center">No records found.</b>
                        </div>
                    </template>
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0"><b> Album Master </b></h5>
                            <div>
                                <Button icon="pi pi-refresh" @click="search(2)"
                                    style="background-color: #349ce4; border: 1px solid #349ce4"
                                    v-tooltip.bottom="'Refresh'" />
                                <Button icon="pi pi-plus" class="ml-2" style="background-color: #349ce4"
                                    v-tooltip.bottom="'Add'" @click="openNew" />
                            </div>
                        </div>
                        <div style="text-align: right; font-weight: bold;margin-top: 1%;">
                            <span>Total Album :</span>{{ totalRecords }}
                        </div>
                    </template>
                    <template #grid="slotProps">
                        <div class="grid grid-nogutter" v-if="slotProps.items">
                            <div class="col-12 md:col-4" v-for="(item, index) in slotProps.items" :key="index">
                                <div class="card m-3 border-1 surface-border" style="background-color: #F6F6F6; box-shadow:rgba(0, 0, 0, 0.5) 0px 8px 12px 0px !important;">
                                    <div style="height: 30px;">
                                        <span v-if="item.status=='Active' ||item.status=='active'"><badge :value=item.status severity="success"></badge></span>
                            <span v-else-if="item.status=='InActive' ||item.status=='In Active'"><badge :value=item.status severity="warning"></badge></span>
                            <span v-else-if="item.status=='Delete' ||item.status=='Deleted'"><badge :value=item.status severity="danger"></badge></span>
                            <span v-else>-</span>
                                    </div>
                                    <div class="text-center" style="height: 50px;">
                                        <div>
                                            <p class="text-2xl font-bold" style="color:#274461"><b>{{ capitalizeFirstLetter(item.album_name)
                                                    }}</b> </p>
                                        </div>
                                    </div>
                                    <div class="flex align-items-center justify-content-center">
                                         <!-- <button 
                                            style="background-color: #22BABB;border: 1px solid #22BABB;" 
                                            class="p-button p-button-sm flex-auto ml-2" 
                                            type="button" 
                                            @click="editProduct(item)">
                                            <span class="p-button-icon p-button-icon-left pi pi-pencil"></span>
                                            <span class="p-button-label" data-pc-section="label" style="margin-left: -20%">Edit</span>
                                        </button>  -->
             <Button
                                            icon="pi pi-pencil"
                                            title="Edit Client"
                                            v-tooltip.bottom="'Edit'"
                                            class="p-button-rounded p-button-warning mr-2"
                                            @click="editProduct(item)"
                                            ></Button>&nbsp;&nbsp; 
                 <!-- <button style="background-color: #F65501;border: 1px solid #F65501;" 
                                                class="p-button p-button-sm flex-auto ml-2" 
                                                type="button" 
                                                @click="confirmDeleteProduct(item)">
                                            <span class="p-button-icon p-button-icon-left pi pi-trash"></span>
                                            <span class="p-button-label" data-pc-section="label" style="margin-left: -20%">Delete</span>
                                        </button>  -->
                                        <Button
                                                icon="pi pi-eye"
                                                v-tooltip.bottom="'View'"
                                                class="p-button-rounded p-button-success mr-2"
                                                @click="showCategories(item)"
                                            ></Button>
                                          &nbsp;&nbsp; 
                 <!-- <button style="background-color: #008C72;border: 1px solid #008C72;" 
                                                class="p-button p-button-sm flex-auto ml-2" 
                                                type="button" @click="showCategories(item)">
                                            <span class="p-button-icon p-button-icon-left pi pi-eye"></span>
                                            <span class="p-button-label" data-pc-section="label" style="margin-left: -20%">Categories</span>
                                        </button>  -->
                                                 
                                            <Button
                                                icon="pi pi-trash"
                                                v-tooltip.bottom="'Delete'"
                                                class="p-button-rounded p-button-danger mr-2"
                                                @click="confirmDeleteProduct(item)"
                                            ></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </template>
                </DataView> 

                <!-- --------------------local--------------------- -->
                
                <!-- <DataView :value="products" :layout="layout" :rows="rows">
                    <template #empty>
                        <div class="text-center">
                            <b style="text-align: center">No records found.</b>
                        </div>
                    </template>
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0"><b> Album Master </b></h5>
                            <div>
                                <Button icon="pi pi-refresh" @click="search(2)"
                                    style="background-color: #349ce4; border: 1px solid #349ce4"
                                    v-tooltip.bottom="'Refresh'" />
                                <Button icon="pi pi-plus" class="ml-2" style="background-color: #349ce4"
                                    v-tooltip.bottom="'Add'" @click="openNew" />
                            </div>
                        </div>
                        <div style="text-align: right; font-weight: bold;margin-top: 1%;">
                            <span>Total Album :</span>{{ totalRecords }}
                        </div>
                    </template>
                    <template #grid="slotProps">
                        <div class="grid grid-nogutter" v-if="slotProps.items"> -->
                        <!-- <div class="col-12 md:col-4">
                            <div class="card m-3 border-1 surface-border"
                                style="background-color: #F6F6F6; box-shadow:rgba(0, 0, 0, 0.5) 0px 8px 12px 0px !important;">
                                <div style="height: 30px;">
                                    <span v-if="item.status == 'Active' || item.status == 'active'">
                                        <badge :value=item.status severity="success"></badge>
                                    </span>
                                    <span v-else-if="item.status == 'InActive' || item.status == 'In Active'">
                                        <badge :value=item.status severity="warning"></badge>
                                    </span>
                                    <span v-else-if="item.status == 'Delete' || item.status == 'Deleted'">
                                        <badge :value=item.status severity="danger"></badge>
                                    </span>
                                    <span v-else>-</span>
                                </div>
                                <div class="text-center" style="height: 50px;">
                                    <div>
                                        <p class="text-2xl font-bold" style="color:#274461"><b>{{
            capitalizeFirstLetter(item.album_name)
        }}</b> </p>
                                    </div>
                                </div>
                                <div class="flex align-items-center justify-content-center">

                                    <Button icon="pi pi-pencil" title="Edit Client" v-tooltip.bottom="'Edit'"
                                        class="p-button-rounded p-button-warning mr-2"
                                        @click="editProduct(item)" />&nbsp;&nbsp;

                                    <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'"
                                        class="p-button-rounded p-button-danger mr-2"
                                        @click="confirmDeleteProduct(item)" />&nbsp;&nbsp;

                                    <Button icon="pi pi-eye" v-tooltip.bottom="'View'"
                                        class="p-button-rounded p-button-success mr-2" @click="showCategories(item)" />
                                </div>
                            </div>
                        </div>


                    </template>
                </DataView>  -->



                <div class="pageno">
                   
                        <Paginator
                  :rows="rows"
                  :totalRecords="totalRecords"
                  :rowsPerPageOptions="perPageOptions"
                  @page="onPageChange"
                ></Paginator>
                </div>
                <Dialog v-model:visible="productDialog" @hide="reset" :style="{ width: '600px' }" header="Album Form"
                    :modal="true">
                    <div class="col-12">
                        <div class="card">
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-12">
                                    <label for="name">Album Name</label>
                                    <InputText id="name" type="text" v-model.trim="product.album_name"
                                        required="true" />
                                </div>
                                <div class="field col-12 md:col-12">
                                    <label for="name">Album Url</label>
                                    <InputText id="name" type="text" v-model.trim="product.album_url" required="true" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <Button style="
                background-color: white;
                border: 1px solid #349ce4;
                color: #349ce4;
              " v-if="product._id" label="UPDATE" icon="pi pi-check" class="p-button mr-1 mb-1" @click="adduser" />
                        <Button v-else style="
                background-color: white;
                border: 1px solid #349ce4;
                color: #349ce4;
              " label="ADD" icon="pi pi-check" class="p-button mr-1 mb-1" @click="adduser" />&nbsp;&nbsp;&nbsp;
                        <Button style="background-color: #349ce4" label="Cancel" icon="pi pi-times"
                            class="p-button mr-1 mb-1" @click="reset" />
                    </div>
                </Dialog>
                <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm"
                    :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete <b>{{ product.album_name }}</b>?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text"
                            @click="deleteProductDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deletegroup" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import BreadcrumbService from "../service/BreadcrumbService";
import JsonExcel from "vue-json-excel";
import {
    GoogleMap,
    Marker,
    MarkerCluster,
    InfoWindow,
    GMapMarker,
    Polyline,
} from "vue3-google-map";
import apis from "@/apis";
import axios from "axios";
import ProgressSpinner from "primevue/progressspinner";
export default {
    data() {
        return {
            rows: 6,
            rowsPerPage: 6,
            perPageOptions: [6, 10],
            layout: "grid",
            sortKey: null,
            sortOrder: null,
            sortField: null,
            sortOptions: [
                { label: "Price High to Low", value: "!price" },
                { label: "Price Low to High", value: "price" },
            ],
            status_dropdown: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            type_dropdown: [
                { name: "Image", value: "image" },
                { name: "Video", value: "video" },
            ],
            type_selected: "",
            search_status: "",
            vehicle_search: "",
            search_name: "",
            selectedvehicle: { name: "", id: "" },
            selecteduser: { name: "", id: "" },
            attachments: "",
            previewImage: null,
            item: {},
            client_id_search: "",
            user_key: "",
            start: "",
            end: "",
            searchme: "",
            name: "",
            
           

            page_no:1,
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            file_attachment: "",
            pick_search: "",
            end_pick_search: "",
            user_type_search: "",
            selectgroupstatus: { name: "", value: "" },
            selectedstatus: { name: "", value: "" },
            products: null,
            productDialog: false,
            deleteProductDialog: false,
            deleteProductsDialog: false,
            lazyParams: {},
            product: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            limit: 6,
            columns: [],
            pageno: 1,
            submitted: false,
            totalRecords: 0,
            id: "",
            BreadcrumbService: null,
            breadcrumbHome: {},
            breadcrumbItems: [],
        };
    },
    productService: null,
    async created() {
        this.initFilters();
        this.user_key = localStorage.getItem("user_key");
        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.Album();
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;

    },
    async mounted() {
        this.id = this.$route.params.id;
        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            await this.get_count();
        }
        await this.get_list();
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                await this.get_count();
                this.get_list();
            }
        },
    },
    methods: {
        // async onPageChange(event) {
        //     this.currentPage = event.page + 1;
        //     this.page_no = event.page + 1;
        //     this.rows = event.rows;
        //     this.limit = event.rows;
        //     console.log('Current page:', this.currentPage, 'Rows:', this.rows);
        //     await this.get_list();
        //     await this.get_count();
        // },

        async onPageChange(event) {
      this.currentPage = event.page + 1;
      this.page_no = event.page + 1;
      this.rows = event.rows;
      this.limit = 6;
      await this.get_list();
      await this.get_count();
    },
        window_up() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        capitalizeFirstLetter(str) {
            if (str && typeof str === "string") {
                return str.charAt(0).toUpperCase() + str.slice(1);
            } else {
                return "";
            }
        },
        isImage(url) {
            return /\.(jpeg|jpg|gif|png)$/i.test(url);
        },
        async date_time_prefix() {
            const currentDateTime = new Date();
            const formattedDate = currentDateTime
                .toISOString()
                .split("T")[0]
                .replace(/-/g, "_");
            const formattedTime = currentDateTime
                .toTimeString()
                .split(" ")[0]
                .replace(/:/g, "_");
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            }
        },
        async search(count) {
            if (count == 2) {
                this.search_status = "";
                this.search_name = "";
                this.type_selected = "";
            }
            await this.get_list();
            await this.get_count();
        },
        async viewProduct(product) {
            console.log(JSON.stringify(product));
            await localStorage.setItem("savegroupdata", JSON.stringify(product));
            this.$router.push({ name: "groupProfile" });
        },
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            if (this.totalRecords > 0) {
                this.get_list();
            }
        },
        get_count: function () {
            var data = {
                count: true,
                album_name: this.search_name,
            };
            this.isLoadingModel = true;
            var promise = apis.AlbumList(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                console.log(response);
                this.totalRecords = response.data.data;
                if(this.totalRecords>10)
                {
                    this.perPageOptions= [6, 10];
                    this.perPageOptions.push(this.totalRecords);   
                }
            });
            console.log(data);
        },
        get_list: function () {
            var data = {
                limit: this.rows,
                page_no: this.page_no,
                count: false,
                album_name: this.search_name,
            };
            console.log(data);
            this.isLoadingModel = true;
            var promise = apis.AlbumList(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                console.log(response);
                this.products = response.data.data;
                console.log(this.products[0]);
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });
            console.log(data);
        },
        openNew() {
            this.product = {};
            this.submitted = false;
            this.productDialog = true;
        },
        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        async adduser() {
            this.submitted = true;
            if (!this.product.album_name) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Album name",
                    life: 3000,
                });
                return false;
            }
            //edit
            if (this.product._id) {
                // alert("edit");
                var data = {
                    _id: this.product._id,
                    album_name: this.product.album_name,
                    album_url: this.product.album_url,

                };
                this.isLoadingModel = true;
                var promise = apis.AlbumEdit(data);
                promise
                    .then((responseapi) => {
                        this.$swal(responseapi.data.data.message);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
            //add-----------------------------------------------------------------------------------------------------------------
            else {
                var data1 = {
                    album_name: this.product.album_name,
                    album_url: this.product.album_url,
                    category_list: [],

                };
                console.log(data1);
                // return false;
                this.isLoadingModel = true;
                var promises = apis.AlbumAdd(data1);
                promises
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal(response.data.data.message);
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
        },
        reset() {
            this.product = {};
            this.selectedstatus = { name: "", value: "" };
            this.attachments = "";
            this.previewImage = null;
            this.productDialog = false;
        },
        format_time(data) {
            if (data) {
                const date = new Date(data);
                return date;
            } else {
                return "";
            }
        },
        editProduct(product) {
            this.product = { ...product };
            this.productDialog = true;
        },
        showCategories(product) {
            this.product = { ...product };
            this.$router.push({ name: "category_master", params: { id: this.product._id } });
        },
        confirmDeleteProduct(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        deleteProduct() {
            this.products = this.products.filter((val) => val.id !== this.product.id);
            this.deleteProductDialog = false;
            this.product = {};
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Product Deleted",
                life: 3000,
            });
        },
        deletegroup() {
            if (this.product._id) {
                var data = {
                    _id: this.product._id,
                };
                this.isLoadingModel = true;
                var promise = apis.AlbumDelete(data);
                promise.then((responseapi) => {
                    this.isLoadingModel = false;
                    if (responseapi.data.data.status == true) {
                        this.deleteProductDialog = false;
                        this.$swal(responseapi.data.data.message);
                        this.get_list();
                        this.get_count();
                    } else {
                        this.$swal("error to Delete Record");
                    }
                });
            }
        },
        createId() {
            let id = "";
            var chars =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 5; i++) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        },
        async exportCSV() {
            this.limit = this.totalRecords;
            this.get_list();
            await this.$refs.dt.exportCSV();
        },
        confirmDeleteSelected() {
            this.deleteProductsDialog = true;
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    components: {
        downloadExcel: JsonExcel,
        GoogleMap,
        Marker,
        MarkerCluster,
        InfoWindow,
        GMapMarker,
        Polyline,
        ProgressSpinner,
    },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";

.image-wrapper {
    height: 150px;
}

.circle {
    width: 100px;
    height: 100px;
    line-height: 500px;
    border-radius: 50%;
    font-size: 50px;
    color: #fff;
    text-align: center;
    background: #0cd4e2
}
</style>
